import nextId from 'react-id-generator';

export const generateId = () => nextId('PermitType');
